module.exports = __webpack_public_path__ + "assets/img/station18.2808dda4.png";